

export class PaymentTypeDto implements IPaymentTypeDto {
    id!: number;
    paymentType!: string | undefined;
    isActive!: boolean;

    constructor(data?: IPaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentType = _data["paymentType"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentType"] = this.paymentType;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IPaymentTypeDto {
    id: number;
    paymentType: string | undefined;
    isActive: boolean;
}

